import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ToastModule} from 'primeng/toast';
import {Observable} from 'rxjs';
import {SaleReportPageObject} from '../../entities/sale-report-page-object/sale-report-page-object';
import {SaleReportPageOrchestrator} from '../../services/sale/sale-report-page.orchestrator';
import {MainComponent} from '../main/main.component';
import {SaleReportsSectionComponent} from './sale-reports-section/sale-reports-section.component';

@Component({
  selector: 'em-sale-report-page',
  templateUrl: './sale-report-page.component.html',
  imports: [SaleReportsSectionComponent, CommonModule, ToastModule, MainComponent],
})
export class SaleReportPageComponent {
  saleReportObject$: Observable<SaleReportPageObject>;

  constructor(
    readonly orchestrator: SaleReportPageOrchestrator,
    readonly route: ActivatedRoute,
  ) {
    let saleReportId: string | undefined;

    if (route.snapshot.params['saleReportId']) {
      saleReportId = atob(route.snapshot.params['saleReportId']);
    }

    if (!saleReportId) {
      throw new Error('No sale report id found');
    }

    this.saleReportObject$ = orchestrator.get(saleReportId);
  }
}
